// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contentful-entity-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: -5px;
  margin-bottom: 10px; }
  .contentful-entity-list > li {
    flex: 1 1 300px;
    padding: 5px; }
`, "",{"version":3,"sources":["webpack://./src/components/contentful/EntitySelector.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,mBAAmB,EAAA;EALrB;IAQI,eAAe;IACf,YAAY,EAAA","sourcesContent":[".contentful-entity-list {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  margin: -5px;\n  margin-bottom: 10px;\n\n  > li {\n    flex: 1 1 300px;\n    padding: 5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
